import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { importProvidersFrom, provideBrowserGlobalErrorListeners } from '@angular/core';
import { CalAngularModule } from '@cvx/cal-angular';
import { Config } from '@cvx/cal-angular';
import { environment } from 'src/environments/environment';
import { App } from './app/app';


import { applicationConfig } from './app/app.config';

bootstrapApplication(App, applicationConfig)
  .catch(err => console.error(err));
